import { Construction } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function AdminHistoricoPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Histórico</h2>
        <p className="text-muted-foreground">
          Histórico de ações e eventos do sistema
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Construction className="h-5 w-5" />
            Em Construção
          </CardTitle>
          <CardDescription>
            Esta funcionalidade ainda está sendo desenvolvida
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Em breve você poderá visualizar o histórico completo de ações do sistema, 
            incluindo sincronizações, envios de email e alterações de configuração.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
